// extracted by mini-css-extract-plugin
export default {"settingsTitle":"styles_settingsTitle__JNqPj","narrow":"styles_narrow__y34ro","subTitle":"styles_subTitle__TP0V-"};